import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sunrise_sunset)?_c('div',[_vm._v(" EGDM "),_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-weather-sunset-up")]),_vm._v(" Sunrise:"+_vm._s(_vm.sunrise_sunset.local.sunrise)+" "),_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-weather-sunset-down")]),_vm._v(" Sunset: "+_vm._s(_vm.sunrise_sunset.local.sunset)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }